var _react_refresh_temp_1, _react_refresh_temp_2;
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { C } from '#integrations';
import styles from './Separator.module.css';
const LINE_ORIENTATION_CLASS_MAP = {
    horizontal: styles.SeparatorLineHorizontal,
    vertical: styles.SeparatorLineVertical,
};
const ORIENTATION_CLASS_MAP = {
    horizontal: styles.SeparatorHorizontal,
    vertical: styles.SeparatorVertical,
};
const SeparatorLine = ({ orientation = 'horizontal' }) => (_jsx("div", { "aria-orientation": orientation, className: C(styles.SeparatorLine, LINE_ORIENTATION_CLASS_MAP[orientation]), role: "separator" }));
_react_refresh_temp_1 = SeparatorLine;
$RefreshReg$(_react_refresh_temp_1, "SeparatorLine");
export const Separator = ({ isFixedWidth, label, orientation = 'horizontal', }) => (_jsx("div", { className: C(styles.Separator, ORIENTATION_CLASS_MAP[orientation], isFixedWidth && styles.FixedWidth), children: !label ? (_jsx(SeparatorLine, { orientation: orientation })) : (_jsxs(_Fragment, { children: [_jsx(SeparatorLine, {}), label, _jsx(SeparatorLine, {})] })) }));
_react_refresh_temp_2 = Separator;
$RefreshReg$(_react_refresh_temp_2, "Separator");
